import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { getUser, login as loginApi, logout as logoutApi, register as registerApi } from '../services/api'

const useAuthStore = create(
    persist(
        (set, get) => ({
            user: null,
            token: null,
            isLoading: false,
            isAuthenticated: false,
            isInitialized: false,

            login: async (email, password) => {
                set({ isLoading: true })
                try {
                    const response = await loginApi(email, password)
                    const { user, token } = response.data

                    localStorage.setItem('auth_token', token)
                    set({ user, token, isAuthenticated: true, isLoading: false })

                    return { success: true }
                } catch (error) {
                    set({ isLoading: false })
                    return {
                        success: false,
                        error: error.response?.data?.message || 'Login failed'
                    }
                }
            },

            register: async (data) => {
                set({ isLoading: true })
                try {
                    const response = await registerApi(data)
                    const { user, token } = response.data

                    localStorage.setItem('auth_token', token)
                    set({ user, token, isAuthenticated: true, isLoading: false })

                    return { success: true }
                } catch (error) {
                    set({ isLoading: false })
                    return {
                        success: false,
                        error: error.response?.data?.message || 'Registration failed'
                    }
                }
            },

            logout: async () => {
                try {
                    await logoutApi()
                } catch (error) {
                    // Ignore logout errors
                }
                localStorage.removeItem('auth_token')
                set({ user: null, token: null, isAuthenticated: false })
            },

            setToken: async (newToken) => {
                localStorage.setItem('auth_token', newToken)
                set({ token: newToken })
                await get().checkAuth()
            },

            checkAuth: async () => {
                const token = localStorage.getItem('auth_token')
                if (!token) {
                    set({ isAuthenticated: false, isInitialized: true })
                    return
                }

                try {
                    const response = await getUser()
                    set({ user: response.data, token, isAuthenticated: true, isInitialized: true })
                } catch (error) {
                    localStorage.removeItem('auth_token')
                    set({ user: null, token: null, isAuthenticated: false, isInitialized: true })
                }
            },

            initializeAuth: async () => {
                const { isInitialized, checkAuth } = get()
                if (isInitialized) return
                await checkAuth()
            },

            isAdmin: () => {
                const { user } = get()
                return user?.role?.name === 'admin'
            },

            isChecker: () => {
                const { user } = get()
                return user?.role?.name === 'checker'
            },

            isCashier: () => {
                const { user } = get()
                return user?.role?.name === 'cashier'
            },
        }),
        {
            name: 'auth-storage',
            partialize: (state) => ({
                token: state.token,
                user: state.user,
                isAuthenticated: state.isAuthenticated
            }),
        }
    )
)

export default useAuthStore
